export const TEST_SCENARIOS = 'TEST_SCENARIOS';

export const CONDUCT_DESIGN_CONFIRMATION_ENTITY = 'Conduct Design Confirmation Workshops'

export const GENERATE_INITIAL_USER_STORY_INVENTORY = 'Generate initial user story inventory';

export const ESTABLISH_PROJECT_TOOLS = 'Establish project tools / controls';

export const REFINE_USER_STORIES_CONFIRMALL = 'CONFIRM_ALL';

export const TILE_DETAILS = 'TILE_DETAILS';
